export class AssetOnAssetManagementPage {
    assetOnAssetManagementPageId: number;
    baseAssetId: number;
    customerId: number;
    isGlobal: boolean;
    isBackground: boolean;
}